import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import Portal from '../../../components/Portal';
import LineOfBusinessTable from '../components/LineOfBusinessTable';

const LineOfBusinessList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-p-24">
      <Portal portalId="header-left-content">
        <span className="portal-header">Lines of Business</span>
      </Portal>
      {pageSize && <LineOfBusinessTable />}
    </Card>
  );
};
export default LineOfBusinessList;
